import React from "react";
import {
  render,
  MARK_SUBSCRIPT,
  MARK_SUPERSCRIPT,
} from "storyblok-rich-text-react-renderer";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

type Props = {
  summary: string;
  btn2: string;
  handleHeroButton: React.MouseEventHandler;
};

export const EventDescription: React.FC<Props> = ({
  summary,
  btn2,
  handleHeroButton,
}) => {
  return (
    <div
      className={classNames(
        "mb-20 px-5 text-center",
        "lg:mx-auto lg:mb-25 lg:max-w-3xl lg:px-13",
        "xxl:mx-auto xxl:mb-40 xxl:max-w-4xl xxl:px-0",
      )}
    >
      <p
        className={classNames(
          "mb-5 text-regular text-base-400",
          "xxl:text-medium",
        )}
      >
        {render(summary, {
          markResolvers: {
            [MARK_SUBSCRIPT]: (children) => <sub>{children}</sub>,
            [MARK_SUPERSCRIPT]: (children) => <sup>{children}</sup>,
          },
        })}
      </p>
      <button
        className="text-regular text-primary-content [&>svg.svg-inline--fa]:align-middle"
        onClick={handleHeroButton}
      >
        {btn2}
        <FontAwesomeIcon icon={faChevronRight} className="fa-2xs ml-2.5" />
      </button>
    </div>
  );
};
